import { render, staticRenderFns } from "./cabinetlogs.vue?vue&type=template&id=6caba0ed&"
import script from "./cabinetlogs.vue?vue&type=script&lang=js&"
export * from "./cabinetlogs.vue?vue&type=script&lang=js&"
import style0 from "./cabinetlogs.vue?vue&type=style&index=0&id=6caba0ed&prod&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports